import { FinaComputedConsentStatus } from "Shared/util/types/api";

export const isCriticalConsentStatus = (status: FinaComputedConsentStatus) =>
    [
        FinaComputedConsentStatus.NotProvided,
        FinaComputedConsentStatus.Expired,
    ].includes(status);
